import React from 'react';
import ReactMarkdown from 'react-markdown';

import markdownUrlPolicy, { SafeMarkdownImage } from '../utils/markdownUrlPolicy';

/**
 * Render markdown through the application-wide URL and image safety policy.
 * Callers may extend component rendering, but cannot override either security
 * boundary.
 */
export default function SafeMarkdown({ components = {}, ...props }) {
  const safeComponents = { ...components, img: SafeMarkdownImage };

  return (
    <ReactMarkdown
      {...props}
      components={safeComponents}
      urlTransform={markdownUrlPolicy}
    />
  );
}
